import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { z } from "zod";

export function useSafeSearchParams<S extends z.ZodTypeAny>(schema: S): z.infer<S> {
  const [searchParams] = useSearchParams();

  // Stable plain object from URLSearchParams
  const raw = useMemo(() => Object.fromEntries(searchParams.entries()), [searchParams]);

  // Validate (no throw) then pick data or defaults
  const data = useMemo(() => {
    const result = schema.safeParse(raw);
    if (result.success) return result.data;

    // Fallback to defaults derived from the schema
    // (parse of {} applies .default()s and keeps optionals undefined)
    return schema.parse({});
  }, [raw, schema]);

  return data as z.infer<S>;
}
